/*
  Add functionality to "Add Buttons" in WYSIWYG
*/

// export function editorContentAdditions() {
//   //wrap all buttons with a wrapper to handle responsive - This works with 'Add Buttons' feature in the wp editor
//   var target = '.btn',
//       invert = ':not(' + target + ')',
//       wrap = '<div class="button-wrapper">',
//       breakpoints = $('.editor-content-wrp > *'+invert),
//       inlineStyle,
//       wrapStyles = [];

//   $('.editor-content-wrp .btn').each(function( ) {
//     wrapStyles.push($(this).parent().attr('style'))
//   });

//   $('.editor-content-wrp').each(function( ) {
//     $(this).find('.btn').unwrap();
//   });

//   breakpoints.each(function(){
//     $(this).nextUntil(invert).wrapAll(wrap);
//   });

//   breakpoints.first().prevUntil(invert).wrapAll(wrap);

//   let stylePosition = 0;

//   $('.editor-content-wrp .button-wrapper').each(function() {
//     let childrenCount = $(this).children().length;

//     if (wrapStyles[stylePosition]) {
//       if (wrapStyles[stylePosition] == 'text-align: right;') {
//         inlineStyle = ('justify-content: flex-end;');
//       } else if (wrapStyles[stylePosition] == 'text-align: center;') {
//         inlineStyle = ('justify-content: center;');
//       } else {
//         inlineStyle = ('justify-content: flex-start;');
//       }

//       $(this).attr('style', inlineStyle);
//     }

//     stylePosition = stylePosition + childrenCount;
//   });
//   //wrap all buttons with a wrapper to handle responsive - This works with 'Add Buttons' feature in the wp editor
// }


// New alignment logic - from inline to classes
export function editorContentAdditions() {
  const target = '.btn',
        invert = ':not(' + target + ')',
        wrapHtml = '<div class="button-wrapper">',
        breakpoints = $('.editor-content-wrp > *' + invert);

  // helper to detect alignment from a jQuery element
  function detectAlignment($el) {
    if (!$el || !$el.length) return '';

    // common class name variants used by different editors/themes/plugins
    if ($el.hasClass('align-right') || $el.hasClass('alignright') || $el.hasClass('text-right') || $el.hasClass('has-text-align-right')) return 'right';
    if ($el.hasClass('align-center') || $el.hasClass('aligncenter') || $el.hasClass('text-center') || $el.hasClass('has-text-align-center')) return 'center';
    if ($el.hasClass('align-left') || $el.hasClass('alignleft') || $el.hasClass('text-left') || $el.hasClass('has-text-align-left')) return 'left';

    // check inline style attribute (e.g. style="text-align:center;")
    const inline = ($el.attr('style') || '').replace(/\s+/g, '').toLowerCase();
    if (inline.indexOf('text-align:center') !== -1) return 'center';
    if (inline.indexOf('text-align:right') !== -1) return 'right';
    if (inline.indexOf('text-align:left') !== -1) return 'left';

    // fallback to computed style
    const computed = $el.css('text-align');
    if (computed === 'center' || computed === 'right' || computed === 'left') return computed;

    return '';
  }

  // 1) record alignment on each button BEFORE we unwrap/remove parents
  $('.editor-content-wrp .btn').each(function() {
    const $btn = $(this);
    // try the direct parent first, then fallback to closest block ancestor
    const $parent = $btn.parent();
    let align = detectAlignment($parent);

    if (!align) {
      // maybe class is on a grandparent (rare), try closest block wrapper
      align = detectAlignment($btn.closest('p,div,li,ol,ul'));
    }

    $btn.data('align', align); // '', 'left', 'center' or 'right'
  });

  // 2) unwrap buttons (remove their wrapper elements like <p> or <div>)
  $('.editor-content-wrp .btn').each(function() {
    $(this).unwrap();
  });

  // 3) group/wrap buttons as before
  breakpoints.each(function() {
    $(this).nextUntil(invert).wrapAll(wrapHtml);
  });
  // the first group that appears before first breakpoint
  breakpoints.first().prevUntil(invert).wrapAll(wrapHtml);

  // 4) apply a class (or classes) to the wrapper according to stored alignment
  $('.editor-content-wrp .button-wrapper').each(function() {
    const $wrapper = $(this);
    const $firstBtn = $wrapper.find('.btn').first();
    let align = ($firstBtn.length && $firstBtn.data('align')) ? $firstBtn.data('align') : '';

    // fallback: maybe the wrapper itself or ancestors have a class (if not unwrapped earlier)
    if (!align) {
      align = detectAlignment($wrapper.parent()) || detectAlignment($wrapper.closest('p,div,li,ol,ul'));
    }

    // Add both an alignment class and a bootstrap-style justify class (pick whatever you use)
    if (align === 'right') {
      $wrapper.addClass('justify-content-end');
    } else if (align === 'center') {
      $wrapper.addClass('justify-content-center');
    } else {
      $wrapper.addClass('justify-content-start'); // default/left
    }
  });
}
// New alignment logic - from inline to classes
